import * as config from '@terraframing-suite/rx-config';
import { find } from 'lodash-es';
import { InputRow } from './InputRow';

export function LimeInstanceInputs({ inputs }) {
  return (
    <>
      <InputRow name="Application State" value={inputs?.state} />
      <InputRow name="Ref Lime Quality" value={inputs?.referenceQuality} />
      <InputRow
        name="L Source"
        value={find(config.lime.sources, { id: inputs?.source })?.label}
      />
      <InputRow name="CCE" value={inputs?.qualityVariables?.cce} />
      <InputRow
        name="Calcium Percentage"
        value={inputs?.qualityVariables?.calcium}
      />
      <InputRow
        name="Mag Percentage"
        value={inputs?.qualityVariables?.magnesium}
      />
      {Object.entries(inputs?.qualityVariables || {})
        .filter(([key]) => key.startsWith('ms'))
        .map(([key, value], i) => {
          const header = i ? '' : 'Sieve Size / Percentage';
          return (
            <InputRow
              name={header}
              value={[/ms(\d+)/.exec(key)[1], value].join(' / ')}
              key={i}
            />
          );
        })}
      <InputRow name="RNV" value={inputs?.quality} />
    </>
  );
}
